import { FC } from 'react';
import { RecognitionsLayout } from 'pages/atoms';
import { RecognitionsAllowancesList } from 'containers/recognitions';

const RecognitionsAllocationsPage: FC = () => {
  return (
    <RecognitionsLayout>
      <RecognitionsAllowancesList />
    </RecognitionsLayout>
  );
};

export default RecognitionsAllocationsPage;
